export function isGenericEmail(email?: string | null) {
    return email ? /@gmail.com$/i.test(email) : false
}
